module.exports = __webpack_public_path__ + "media/icons/cheers-4a6a7e78.png";